import React from 'react';
import { hasPermission } from '../components/auth/login/Login';
import { useNavigate } from 'react-router-dom';
import DashboardListing from '../components/dashboard/dashboardListing/DashboardListing';

function Dashboard() {

    const canReadDashboard = hasPermission("Property Dashboard", "Dashboard", "read");
    const navigate = useNavigate();

    if (!canReadDashboard) {
        navigate('/no-permission')
    }

    return (
        <div>
            <DashboardListing />
        </div>
    )
}

export default Dashboard